/* Icon Tile — shared image lightbox for content galleries (blog articles, the
   gallery page). Builds the SAME DOM as the product-detail lightbox so the
   existing .ico-lightbox__* CSS styles it identically. Auto-binds to any
   .ico-agal-grid / .ico-gal-grid on the page, and is also exposed as
   window.IcoLightbox.open(slides, startIndex).
   slide = { src, alt, title?, url?, zoom? }
     title -> caption shown bottom-left over the image
     url   -> "View product" link in the caption
     zoom  -> higher-res source used when the image is click-zoomed (else src) */
(function () {
  var box, stage, thumbsBar, cap, capTitle, capLink, fig, img,
      slides = [], idx = 0, built = false,
      zoomed = false, panX = 0, panY = 0, maxX = 0, maxY = 0, down = null;

  function clamp(v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); }

  function build() {
    box = document.createElement('div');
    box.className = 'ico-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Image viewer');
    box.innerHTML =
      '<button type="button" class="ico-lightbox__close" aria-label="Close"><svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M1 1l16 16M17 1L1 17" stroke="currentColor" stroke-width="1.5"/></svg></button>' +
      '<button type="button" class="ico-lightbox__nav ico-lightbox__nav--prev" aria-label="Previous"><svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M15 4l-8 8 8 8" stroke="currentColor" stroke-width="1.5"/></svg></button>' +
      '<div class="ico-lightbox__stage"></div>' +
      '<button type="button" class="ico-lightbox__nav ico-lightbox__nav--next" aria-label="Next"><svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M9 4l8 8-8 8" stroke="currentColor" stroke-width="1.5"/></svg></button>' +
      '<div class="ico-lightbox__thumbs" role="tablist"></div>';
    document.body.appendChild(box);
    stage = box.querySelector('.ico-lightbox__stage');
    thumbsBar = box.querySelector('.ico-lightbox__thumbs');
    // let a vertical mouse-wheel scroll the (horizontal) thumb strip
    thumbsBar.addEventListener('wheel', function (e) {
      if (thumbsBar.scrollWidth <= thumbsBar.clientWidth) return;
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      e.preventDefault();
      thumbsBar.scrollLeft += e.deltaY;
    }, { passive: false });
    box.querySelector('.ico-lightbox__close').addEventListener('click', close);
    box.querySelector('.ico-lightbox__nav--prev').addEventListener('click', function () { show(idx - 1); });
    box.querySelector('.ico-lightbox__nav--next').addEventListener('click', function () { show(idx + 1); });
    box.addEventListener('click', function (e) { if (e.target === box || e.target === stage) close(); });
    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
    built = true;
  }

  function renderThumbs() {
    thumbsBar.innerHTML = '';
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ico-lightbox__thumb';
      var t = document.createElement('img');
      t.src = s.src; t.alt = '';
      b.appendChild(t);
      b.addEventListener('click', function () { show(i); });
      thumbsBar.appendChild(b);
    });
  }

  function applyPan() { if (fig) fig.style.transform = 'translate(' + panX + 'px,' + panY + 'px)'; }

  function exitZoom() {
    zoomed = false;
    box.classList.remove('is-zoom');
    panX = panY = 0;
    if (img) { img.style.maxWidth = ''; img.style.maxHeight = ''; img.style.width = ''; img.style.height = ''; }
    applyPan();
  }

  function enterZoom() {
    if (!img) return;
    zoomed = true;
    box.classList.add('is-zoom');
    var s = slides[idx];
    var hi = s.zoom || s.src;
    function size() {
      var nw = img.naturalWidth, nh = img.naturalHeight;
      if (!nw || !nh) return;
      img.style.maxWidth = 'none'; img.style.maxHeight = 'none';
      img.style.width = nw + 'px'; img.style.height = nh + 'px';
      maxX = Math.max(0, (nw - stage.clientWidth) / 2);
      maxY = Math.max(0, (nh - stage.clientHeight) / 2);
      panX = panY = 0; applyPan();
    }
    if (hi && img.getAttribute('src') !== hi) {
      img.addEventListener('load', size, { once: true });
      img.src = hi;
    } else { size(); }
  }

  function toggleZoom() { if (zoomed) exitZoom(); else enterZoom(); }

  function show(i) {
    idx = (i + slides.length) % slides.length;
    var s = slides[idx];
    exitZoom();
    stage.innerHTML = '';

    fig = document.createElement('div');
    fig.className = 'ico-lightbox__figure';

    img = document.createElement('img');
    img.className = 'ico-lightbox__media ico-lightbox__img';
    img.src = s.src; img.alt = s.alt || '';
    img.draggable = false;
    fig.appendChild(img);

    // caption (product title + "View product" link) over the image's bottom-left
    cap = document.createElement('div');
    cap.className = 'ico-lightbox__cap';
    var hasCap = false;
    if (s.title) {
      capTitle = document.createElement('span');
      capTitle.className = 'ico-lightbox__cap-title';
      capTitle.textContent = s.title;
      cap.appendChild(capTitle); hasCap = true;
    }
    if (s.url) {
      capLink = document.createElement('a');
      capLink.className = 'ico-lightbox__cap-link';
      capLink.href = s.url;
      capLink.innerHTML = 'View product <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="1.6"/></svg>';
      cap.appendChild(capLink); hasCap = true;
    }
    cap.hidden = !hasCap;
    fig.appendChild(cap);

    // click to zoom / drag to pan
    img.addEventListener('pointerdown', function (e) {
      down = { x: e.clientX, y: e.clientY, px: panX, py: panY, moved: false };
      if (zoomed) { try { img.setPointerCapture(e.pointerId); } catch (err) {} }
    });
    img.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - down.x, dy = e.clientY - down.y;
      if (Math.abs(dx) + Math.abs(dy) > 6) down.moved = true;
      if (zoomed) { panX = clamp(down.px + dx, -maxX, maxX); panY = clamp(down.py + dy, -maxY, maxY); applyPan(); }
    });
    img.addEventListener('pointerup', function (e) {
      if (!down) return;
      var wasClick = !down.moved;
      down = null;
      if (wasClick) toggleZoom();
    });

    stage.appendChild(fig);

    [].forEach.call(thumbsBar.querySelectorAll('.ico-lightbox__thumb'), function (t, k) {
      var on = k === idx;
      t.classList.toggle('is-active', on);
      if (on && thumbsBar.scrollWidth > thumbsBar.clientWidth) {
        t.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    });
  }

  function open(list, start) {
    if (!list || !list.length) return;
    if (!built) build();
    slides = list;
    renderThumbs();
    show(start || 0);
    box.classList.add('is-open');
    document.documentElement.classList.add('ico-lightbox-open');
  }

  function close() {
    if (!box) return;
    exitZoom();
    box.classList.remove('is-open');
    document.documentElement.classList.remove('ico-lightbox-open');
    stage.innerHTML = '';
  }

  window.IcoLightbox = { open: open, close: close };

  function bind() {
    document.querySelectorAll('.ico-agal-grid, .ico-gal-grid').forEach(function (grid) {
      if (grid.dataset.icoLb) return;
      grid.dataset.icoLb = '1';
      var links = [].slice.call(grid.querySelectorAll('a[href]'));
      if (!links.length) return;
      links.forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          // build from currently-visible items so a category filter is respected
          var vis = links.filter(function (l) { return l.offsetParent !== null; });
          if (!vis.length) vis = links;
          var list = vis.map(function (l) {
            return {
              src: l.getAttribute('href'),
              alt: l.getAttribute('data-caption') || '',
              title: l.getAttribute('data-caption') || '',
              url: l.getAttribute('data-product') || '',
              zoom: l.getAttribute('data-zoom') || ''
            };
          });
          open(list, vis.indexOf(a));
        });
      });
    });
  }
  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);
})();
